export default __webpack_public_path__ + "static/media/tiktok.8cddc6f9.png";